import { render, staticRenderFns } from "./tableDesign.vue?vue&type=template&id=3fe6b1ca&scoped=true"
import script from "./tableDesign.vue?vue&type=script&lang=js"
export * from "./tableDesign.vue?vue&type=script&lang=js"
import style0 from "./tableDesign.vue?vue&type=style&index=0&id=3fe6b1ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe6b1ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fe6b1ca')) {
      api.createRecord('3fe6b1ca', component.options)
    } else {
      api.reload('3fe6b1ca', component.options)
    }
    module.hot.accept("./tableDesign.vue?vue&type=template&id=3fe6b1ca&scoped=true", function () {
      api.rerender('3fe6b1ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/containerTemplateComponent/tableDesign.vue"
export default component.exports